module.exports = __webpack_public_path__ + "static/media/raid_forum_theme_1.029d54a2.jpg";